
import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule  } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { WhitespaceValidator } from '../../../validators/text.validator';



@Component({
  selector: 'comment-modal',
  imports: [FormsModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatDialogModule, TranslateModule, WhitespaceValidator],
  templateUrl: './comment-modal.component.html',
  styleUrls: ['./comment-modal.component.scss']
})

export class CommentModalComponent {

  comment: string = '';

  constructor(public dialogRef: MatDialogRef<CommentModalComponent>) { }

  onSubmit(form: NgForm) {
    console.log("submit", form.valid);
    if (form.valid) this.dialogRef.close(this.comment);
  }

}
